






























import { Component, Vue } from "vue-property-decorator";
import CPage from "@/components/form/CustomPage/CPage.vue";
import CBlock from "@/components/form/CustomPage/CBlock.vue";
import store from "@/store";
import { Instruction } from "@/services/instructions";

@Component({
  components: { CBlock, CPage }
})
export default class InstructionsView extends Vue {
  instruction: Instruction = new Instruction(Number(this.$route.params.id));

  get locale() {
    return (
      this.$store?.getters?.LOCALIZATION ||
      window.localStorage.getItem("localization") ||
      "not installed"
    );
  }

  get companyTitle() {
    return store.getters.selectedCompany.title;
  }

  mounted() {
    document.title = `${this.$t(this.$translate.Instructions)} ${
      this.instruction.title
    } | ${this.companyTitle ?? ""}`;
  }
}
